import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    GET_CONTAINER_TYPES,
    GET_MULTI_MODE_MOVEMENT_TYPE_LIST,
    GET_CONTAINER_TYPES_LIST,
    GET_MULTI_MODE_ROUTE_CODE,
    GET_GROUPS_AND_TRANSPORTERS_SUCCESS,
    UPLOAD_CONTAINER_TRIPS,
    DOWNLOAD_CONTAINER_TEMPLATE,
    GET_CONTAINER_TRIPS,
    POST_CONTAINER_TRIPS,
    GET_MASTER_ROUTE_CODE_DETAILS,
    UPLOAD_DOCUMENT,
    GET_CONTAINER_LPP,
    DOWNLOAD_UPLOADED_FILE,
    GET_SOURCE_ICD_BRANCH_LIST,
    GET_ALL_ICD_BRANCH_LIST,
    GET_ICD_DESTINATION_ROUTE_CODE
} from 'Constants/actionConstants';
import Dropdown from 'Components/Dropdown';
import { ReactComponent as DownloadIcon } from "Icons/download.svg";
import { ReactComponent as UploadIcon } from "Icons/upload-blue.svg";
import { ReactComponent as CancelIcon } from 'Icons/cancel.svg';
import DoorToDoor from "./DoorToDoor";
import ICDDestnToConsignee from './ICDDestinationToConsignee';
import HandlingAgent from './HandlingAgent';
import Consignee from './consignee';
import Heading from 'Components/Heading';
import GroupContainer from 'Components/AWLMultiMode/GroupContainer';
import Overlay from 'Components/Overlay';
import Upload from "Components/Upload";
import Checkbox from 'Components/Checkbox';
import Cx from 'classnames';

const providers = [
    { provider_type: 2, provider_name: 'Transporter' },
    { provider_type: 21, provider_name: 'Handling Agent' }
]

const slabObj = {
    description: "",
    slab_name: "",
    pricing_basis_name: '',
    pricing_basis: '',
    market_rate: '',
    qbr: ''
}

const tripObj = {
    stops: [],
    vehicle_details: {},
    movement_type_name: "",
    movement_type: '',
    no_of_container: '',
    remarks: '',
    origin_yard: '',
    destination_yard: '',
    from: '',
    to: '',
    rfq_type: 10,
    slabs: [],
    transporters_group: [],
    transporter_ids: []
}

const icdDestnToConsigneeObj = {
    stops: [],
    vehicle_details: {},
    no_of_trucks: '',
    route_code: '',
    remarks: '',
    from: '',
    to: '',
    bidding_and_payments: {
        qbr: ''
    },
    pricing_basis: '',
    pricing_basis_name: '',
    rfq_type: 10,
    transporters_group: [],
    transporter_ids: []
}

const handlingAgentObj = {
    stops: [],
    movement_type: '',
    movement_type_name: '',
    pricing_basis: '',
    pricing_basis_name: '',
    lpp: '',
    market_rate: '',
    bidding_and_payments: {
        qbr: ''
    },
    remarks: '',
    rfq_type: 10,
    transporters_group: [],
    transporter_ids: [],
    route_code: ''
}

class ContainerTrips extends Component {
    constructor() {
        super(); 
        this.state = {
            trips: [],
            locationList: [],
            selectedProviders: []
        }
    }

    componentDidMount() {
        this.getContainerTypes();
        this.getMultiModalTypes();
        this.getContainerListTypes();
        this.getTrips();
        this.getAllICDBranches();
    }

    getTrips = () => {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_CONTAINER_TRIPS,
            params: {
                limit: 1000,
                offset: 0,
                rfqId: match.params.id,
                rfqType: match.params.type
            },
            onSuccess: (data) => {
                if((data || []).length > 0) {
                    this.setState({
                        trips: data || [],
                        container_trip_type: data[0]['container_trip_type'],
                        container_type_name: data[0]['container_type_name']
                    });
                    // this.props.setContainerTrip(data);
                }
            }
        })
    }

    getSourceICDBranches = (source) => {
        const { dispatch } = this.props;
        const params = {
            source
        }
        dispatch({
            type: GET_SOURCE_ICD_BRANCH_LIST,
            params
        })
    }

    getAllICDBranches = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_ALL_ICD_BRANCH_LIST
        })
    }

    getDestICDRoutecode = (source, destinationYard, tripIndex) => {
        const { dispatch } = this.props;
        const { trips } = this.state;
        const params = {
            source,
            destinationYard
        }
        dispatch({
            type: GET_ICD_DESTINATION_ROUTE_CODE,
            params,
            onSuccess: (data) => {
                trips[tripIndex]['destination'] = data.destination;
                trips[tripIndex]['route_code'] = data.sap_code;
                trips[tripIndex]['distance'] = data.distance;
                trips[tripIndex]['distance_uom'] = data.distance_uom;
                this.setState({ trips, icdDestError: '' })
            },
            onError: (error) => {
                if(error.message){
                    this.setState({icdDestError: error.message})
                }
            }
        })    
    }

    getContainerListTypes = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_CONTAINER_TYPES_LIST
        });
    }

    getContainerTypes = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_CONTAINER_TYPES
        });
    }

    getMultiModalTypes = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_MULTI_MODE_MOVEMENT_TYPE_LIST
        });
    }

    onSelectContanerType = (option) => {
        let { trips, selectedProviders } = this.state;
        if(selectedProviders.length > 0) {
            (selectedProviders || []).forEach(el => {
                const tripsConsigneeIndex = (trips || []).findIndex(el => el.consignee_type);
                const tObj = JSON.parse(JSON.stringify(el.provider_type === 2 ? tripObj : handlingAgentObj));
                tObj['provider_type'] = el['provider_type'];
                tObj['provider_name'] = el['provider_name'];
                if(tripsConsigneeIndex > -1) {
                    trips.splice(tripsConsigneeIndex, 0, tObj);
                } else {
                    trips.push(tObj);
                }
            });
        } else {
            trips = [];
            trips.push({
                ...JSON.parse(JSON.stringify(tripObj))
            });
            if([1, 3].includes(option.id)) {
                trips[0]['provider_type'] = 2;
                trips[0]['provider_name'] = 'Transporter'
            }
        }
        this.setState({
            container_trip_type: option.id,
            container_type_name: option.name,
            trips,
            selectedOption: '',
            selectedProviders: []
        });
    }

    onSelect = (option, index, type) => {
        const { trips } = this.state;
        if(type === 'movement_type') {
            trips[index]['movement_type'] = option.id;
            trips[index]['movement_type_name'] = option.name;
        } else if(type === 'vehicle_type') {
            trips[index]['vehicle_details'] = {
                'vehicle_type_name': option.name,
                'vehicle_type': option.id || option.value
            }
        } else if(type === 'pricing_basis_name') {
            trips[index][type] = option.name
            trips[index]['pricing_basis'] = option.value;
        }
        this.setState({ trips });
    }

    onChange = (e, tripIndex, type) => {
        const { trips } = this.state;
        const { value } = e.target;
        trips[tripIndex].stops[type === 'origin' ? 0 : 1] = {
            [([3].includes(this.state.container_trip_type) || trips[tripIndex]['consignee_type']) ? 'location' : 'city']: value
        }
        this.setState({ trips }, () => {
            const { dispatch } = this.props;
            if(([1,2,3].includes(this.state.container_trip_type) || trips[tripIndex]['consignee_type'])) {
                dispatch({
                    type: GET_MASTER_ROUTE_CODE_DETAILS,
                    params: {
                        limit: 20,
                        offset: 0,
                        from: type === 'origin' ? value : (trips[tripIndex].stops[0] || {})['city'],
                        to: type !== 'origin' ? value : (trips[tripIndex].stops[1] || {})['city'],
                    },
                    onSuccess: (data) => {
                        this.setState({
                            locationList: data || []
                        });
                    }
                })
            } else {
                dispatch({
                    type: GET_MULTI_MODE_ROUTE_CODE,
                    params: {
                        limit: 20,
                        offset: 0,
                        from: type === 'origin' ? value : (trips[tripIndex].stops[0] || {})['city'],
                        to: type !== 'origin' ? value : (trips[tripIndex].stops[1] || {})['city'],
                    }, 
                    onSuccess: (data) => {
                        this.setState({
                            locationList: data || []
                        });
                    }
                })
            }
        })
    }

    onSelectRoutestage = (option, tripIndex, type) => {
        const { trips, container_trip_type } = this.state;
        if(container_trip_type == 1){
            trips[tripIndex]['origin_yard'] = option.departurePtDesc;
            trips[tripIndex]['destination_yard'] = option.destinationPtDesc;
            trips[tripIndex]['distance'] = option.distance;
        }
        else if(container_trip_type == 2){
            if(type == 'origin_yard'){
                trips[tripIndex]['origin_yard'] = option.branch_name;
                trips[tripIndex]['origin_yard_id'] = option.branch_id;
                trips[tripIndex]['distance'] = option.distance;
            } else if(type == 'destination_yard'){
                let assigned = false;
                (trips || []).forEach((el, elIndex) => {
                    if(el.provider_type === 21 && elIndex > tripIndex && !assigned) {
                        assigned = true;
                        trips[elIndex].stops[0] = trips[tripIndex].stops[0];
                        trips[elIndex]['from'] = option.branch_name;
                        trips[elIndex]['origin_yard'] = option.branch_name;
                        trips[elIndex]['origin_yard_id'] = option.branch_id;
                        trips[elIndex]['route_code'] = trips[tripIndex].route_code || '';
                        this.getHandligentLPP(elIndex);
                    }
                })
                trips[tripIndex]['destination_yard'] = option.branch_name;
                trips[tripIndex]['destination_yard_id'] = option.branch_id;
                trips[tripIndex]['distance'] = option.distance;
                this.getDestICDRoutecode(trips[tripIndex].from, option.branch_name, tripIndex)
            }
        }
        this.setState({
            trips
        })
    }

    onSelectLocation = (e, tripIndex, type) => {
        const { trips, container_trip_type } = this.state;
        if(type === 'origin') {
            trips[tripIndex].stops[0] = {
                "state": e.state,
                "city": e.source,
                "country": "India",
                "location": `${e.source}, ${e.state}`,
                "landmark": "",
                "remarks": "",
                "type": 1,
                "sequence": 1
            }
            trips[tripIndex]['origin_yard'] = e.origin_yard;
            trips[tripIndex]['from'] = e.source;
            trips[tripIndex]['routestages'] = e.routestages;
        } 
        else if(type === 'destination') {
            trips[tripIndex].stops[1] = {
                "state": e.state,
                "city": container_trip_type === 2 ? e.destination_yard : e.destination,
                "country": "India",
                "location": `${e.destination}, ${e.state}`,
                "landmark": "",
                "remarks": "",
                "type": 2,
                "sequence": 2
            }
            if(container_trip_type === 2) {
                let assigned = false;
                (trips || []).forEach((el, elIndex) => {
                    if(el.provider_type === 21 && elIndex > tripIndex && !assigned) {
                        assigned = true;
                        trips[elIndex].stops[0] = trips[tripIndex].stops[1];
                        trips[elIndex]['from'] = e.destination_yard;
                        trips[elIndex]['origin_yard'] = e.destination_yard;
                        trips[elIndex]['origin_yard_id'] = e.destination_yard_id;
                        trips[elIndex]['route_code'] = e.sap_code;
                        this.getHandligentLPP(elIndex);
                    }
                })
            }
            trips[tripIndex]['to'] = container_trip_type === 2 ? e.destination_yard : e.destination;
            trips[tripIndex]['destination_yard'] = e.destination_yard;
        }
        if((trips[tripIndex].stops[0] || {})['city'] && (trips[tripIndex].stops[1] || {})['city']) {
            trips[tripIndex]['route_code'] = e.sap_code;
            trips[tripIndex]['distance'] = e.yard_to_yard_distance;
            trips[tripIndex]['routestages'] = e.routestages;
        }
        if(container_trip_type == 2){
            this.setState({ trips }, () => this.getSourceICDBranches(e.source))
        }else{
            this.setState({trips })
        }
    }

    onSelectICDDestnToConsigneeLocation = (e, tripIndex, type) => {
        const { trips } = this.state;
        if(type === 'origin') {
            trips[tripIndex].stops[0] = {
                "state": e.source_state,
                "city": e.source,
                "district": e.source_district,
                "country": "India",
                "location": `${e.source}, ${e.source_district}, ${e.source_state}`,
                "landmark": "",
                "remarks": "",
                "type": 1,
                "sequence": 1
            }
            trips[tripIndex]['from'] = e.source;
        } else if(type === 'destination') {
            trips[tripIndex].stops[1] = {
                "state": e.destination_state,
                "city": e.destination,
                "district": e.destination_district,
                "country": "India",
                "location": `${e.destination}, ${e.destination_district}, ${e.destination_state}`,
                "landmark": "",
                "remarks": "",
                "type": 1,
                "sequence": 1
            }
            trips[tripIndex]['to'] = e.destination;
        }
        if((trips[tripIndex].stops[0] || {})['city'] && (trips[tripIndex].stops[1] || {})['city']) {
            trips[tripIndex]['route_code'] = e.sap_code;
            trips[tripIndex]['distance'] = e.distance;
        }
        this.setState({
            trips
        })
    }

    onChangeTrip = (e, index, type) => {
        const { trips } = this.state;
        const { value } = e.target;
        if(type === 'qbr') {
            trips[index]['bidding_and_payments'] = {
                qbr: (value && Number(value) || value)
            }
        }
        trips[index][type] = ((['no_of_container', 'no_of_trucks' , 'market_rate'].includes(type) && value) ? Number(value) : value);
        this.setState({ trips });
    }

    onAddSlab = (index) => {
        const { trips } = this.state;
        if(!trips[index].slabs) {
            trips[index].slabs = [];
        }
        trips[index].slabs.push({
            ...slabObj
        });
        this.setState({
            trips
        });
    }

    onSelectSlab = (e, tripIndex, slabIndex, type) => {
        const { trips, container_trip_type } = this.state;
        trips[tripIndex].slabs[slabIndex][type] = e.name;
        const trip = trips[tripIndex];
        const slab = trip.slabs[slabIndex];       
        if(container_trip_type !== 3){
            if(type === 'pricing_basis_name') {
                trips[tripIndex].slabs[slabIndex]['pricing_basis'] = e.value;
                if(container_trip_type == 2){
                    if(trip.stops[0].location && trip.origin_yard && trip.destination_yard && (trip.vehicle_details || {}).vehicle_type_name && slab.slab_name && slab.pricing_basis) {
                        this.getSlabLPP(tripIndex, slabIndex);
                    }
                }else{
                    if(trip.stops[0].location && trip.stops[1].location && trip.origin_yard && trip.destination_yard && (trip.vehicle_details || {}).vehicle_type_name && slab.slab_name && slab.pricing_basis) {
                        this.getSlabLPP(tripIndex, slabIndex);
                    }
                }
                
            } else if(type === 'slab_name') {
                if(container_trip_type == 2){
                    if(trip.stops[0].location && trip.origin_yard && trip.destination_yard && (trip.vehicle_details || {}).vehicle_type_name && slab.slab_name && slab.pricing_basis) {
                        this.getSlabLPP(tripIndex, slabIndex);
                    }
                }else{
                    if(trip.stops[0].location && trip.stops[1].location && trip.origin_yard && trip.destination_yard && (trip.vehicle_details || {}).vehicle_type_name && slab.slab_name && slab.pricing_basis) {
                        this.getSlabLPP(tripIndex, slabIndex);
                    }
                }
            }
        } else{
            if(type === 'pricing_basis_name') {
                trips[tripIndex].slabs[slabIndex]['pricing_basis'] = e.value;
                if(trip.stops[0].location && trip.stops[1].location && (trip.vehicle_details || {}).vehicle_type_name && slab.slab_name && slab.pricing_basis) {
                    this.getSlabLPP(tripIndex, slabIndex);
                }
            } else if(type === 'slab_name') {
                if(trip.stops[0].location && trip.stops[1].location && (trip.vehicle_details || {}).vehicle_type_name && slab.slab_name && slab.pricing_basis) {
                    this.getSlabLPP(tripIndex, slabIndex);
                }
            }
        }
        
        this.setState({ trips });
    }

    onChangeSlab = (e, tripIndex, slabIndex, type) => {
        const { trips } = this.state;
        const { value } = e.target;
        trips[tripIndex].slabs[slabIndex][type] = ((['qbr', 'market_rate'].includes(type) && value) ? Number(value): value);
        this.setState({ trips }, () => {
            // const { trips } = this.state;
            // const trip = trips[tripIndex];
            // const slab = (trip.slabs || [])[slabIndex];
            // if(trip.stops[0].location && trip.stops[1].location && trip.origin_yard && trip.destination_yard && (trip.vehicle_details || {}).vehicle_type_name && slab.slab_name && slab.pricing_basis) {
            //     this.getSlabLPP(tripIndex, slabIndex);
            // }
        });
    }

    getSlabLPP = (tripIndex, slabIndex) => {
        const { dispatch, rfq } = this.props;
        const { trips, container_trip_type } = this.state;
        const trip = trips[tripIndex];
        const slab = (trip.slabs || [])[slabIndex];
        const data = {
            "companyId": rfq.companyId,
            "source": trip.stops[0].location,
            // "destination": trip.stops[1].location,
            "pricing_basis": slab.pricing_basis,
            "vehicle_type": (trip.vehicle_details || {}).vehicle_type_name,
            "fuel_type": rfq.fuelType,
            "origin_yard": trip.origin_yard ,
            "destination_yard": trip.destination_yard,
            "container_trip_type": container_trip_type,
            "slab_range": slab.slab_name
        }
        if(container_trip_type == 2){
            data["destination"] = trip.destination;
        }else{
            data["destination"] = trip.stops[1].location;
        }
        dispatch({
            type: GET_CONTAINER_LPP,
            data,
            onSuccess: (data) => {
                if(data) {
                    const { trips } = this.state;
                    trips[tripIndex].slabs[slabIndex]['lpp'] = data.lpp;
                    this.setState({ trips });
                }
            }
        })
    }

    getHandligentLPP = (index) => {
        const { dispatch, rfq } = this.props;
        const { trips } = this.state;
        const trip = trips[index];
        const data = {
            "companyId": rfq.companyId,
            "source": trip.origin_yard,
            "provider_type": trip.provider_type
        }
        dispatch({
            type: GET_CONTAINER_LPP,
            data,
            onSuccess: (data) => {
                if(data) {
                    if(data) {
                        const { trips } = this.state;
                        trips[index]['lpp'] = data.lpp;
                        this.setState({ trips });
                    }
                }
            }
        })
    }

    onDeleteTrip = (index) => {
        const { trips } = this.state;
        trips.splice(index, 1);
        this.setState({ trips });
    }

    getTripObjects = () => {
        const { container_trip_type } = this.state;
        if(container_trip_type === 1) {
            return JSON.parse(JSON.stringify(tripObj));
        } else if(container_trip_type === 3) {
            return JSON.parse(JSON.stringify(icdDestnToConsigneeObj));
        }
    }

    onAddTrip = (index) => {
        const { trips, container_trip_type, container_type_name } = this.state;
        if(container_trip_type === 2) {
            this.setState({
                openProviderSelection: true,
                selectedProviders: [],
                selectedOption: {
                    id: container_trip_type,
                    name: container_type_name
                }
            });
            return;
        }
        const tObj = this.getTripObjects();
        tObj['provider_type'] = trips[0]['provider_type'];
        tObj['provider_name'] = trips[0]['provider_name'];
        trips.push(tObj);
        this.setState({
            trips
        });
    }

    openProviderPopup = (index, type) => {
        const { dispatch } = this.props;
        const { openTransporterPopup, container_trip_type } = this.state;
        dispatch({
            type: GET_GROUPS_AND_TRANSPORTERS_SUCCESS,
            groups: [],
            transporters: [],
            isMultimode: container_trip_type === 1 ? true : false
        })

        this.setState({
            providerTripIndex: index,
            openTransporterPopup: !openTransporterPopup,
            providerType: type
        }, () => {
            if(type) {
                this.props.searchGroupsAndTransporters('', type, true);
            }
        })
    }

    toggleAllTransporters = (group, index, e) => {
        const { trips } = this.state;
        if(!trips[index].transporters_group) {
            trips[index].transporters_group = [];
        }
        const transDetails = trips[index].transporters_group;
        const isExist = transDetails.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            trips[index].transporters_group.splice(isExist, 1);
        } else {
            trips[index].transporters_group.push(JSON.parse(JSON.stringify(group)));
        }
        trips[index]['transporter_ids'] = [];
        (trips[index].transporters_group || []).forEach(el => {
            el['provider_type'] = trips[index]['provider_type'];
            el['provider_name'] = trips[index]['provider_name'];
            (el.transporters || []).map(trans => (
                trips[index]['transporter_ids'].push(trans.id)
            ));
        });
        this.setState({ trips });
    }

    toggleTransporter = (index, transporter, group) => {
        const { trips } = this.state;
        const transGroup = JSON.parse(JSON.stringify(group));
        if(!trips[index].transporters_group) {
            trips[index].transporters_group = [];
        }
        const transDetails = trips[index].transporters_group;
        const isExist = transDetails.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            const isTransporter = (transDetails[isExist].transporters || []).findIndex(trans => trans.id === transporter.id);
            if(isTransporter > -1) {
                trips[index].transporters_group[isExist].transporters.splice(isTransporter, 1);
            } else {
                trips[index].transporters_group[isExist].transporters.push(JSON.parse(JSON.stringify(transporter)));
            }
        } else {
            transGroup.transporters = [];
            transGroup.transporters.push(transporter)
            trips[index].transporters_group.push(transGroup);
        }
        trips[index]['transporter_ids'] = [];
        (trips[index].transporters_group || []).forEach(el => {
            el['provider_type'] = trips[index]['provider_type'];
            el['provider_name'] = trips[index]['provider_name'];
            (el.transporters || []).map(trans => (
                trips[index]['transporter_ids'].push(trans.id)
            ));
        });
        this.setState({ trips });
    }

    onDeleteTransporter = (index, groupIndex, transindex) => {
        const { trips } = this.state;
        trips[index].transporters_group[groupIndex].transporters.splice(transindex, 1);
        if(trips[index].transporters_group[groupIndex].transporters.length === 0) {
            trips[index].transporters_group.splice(groupIndex, 1);
        }
        trips[index]['transporter_ids'] = [];
        (trips[index].transporters_group || []).forEach(el => {
            el['provider_type'] = trips[index]['provider_type'];
            el['provider_name'] = trips[index]['provider_name'];
            (el.transporters || []).map(trans => (
                trips[index]['transporter_ids'].push(trans.id)
            ));
        });
        this.setState({
            trips
        });
    }

    onCancel = () => {
        this.setState({
            trips: [],
            container_trip_type: '',
            container_type_name: '',
            icdDestError: ''
        })
        this.props.setContainerTrip([]);
    }

    onSave = () => {
        const { trips, container_trip_type, container_type_name } = this.state;
        const { dispatch, match } = this.props;
        dispatch({
            type: POST_CONTAINER_TRIPS,
            data: {
                rfq_id: match.params.id,
                container_trip_type,
                container_type_name,
                trips
            },
            onSuccess: this.getTrips
        })
    }

    uploadTrips = (file, isConsignee = 0) => {
        const { dispatch, match } = this.props;
        const { container_trip_type } = this.state;

        dispatch({
            type: UPLOAD_CONTAINER_TRIPS,
            file,
            params: {
                rfqId: match.params.id,
                type: container_trip_type,
                rfqType: match.params.type,
                isConsignee
            },
            onSuccess: () => {
                this.getTrips();
            }
        })
    }

    onDownload = (withData, isConsignee = 0) => {
        const { dispatch, match } = this.props;
        dispatch({
            type: DOWNLOAD_CONTAINER_TEMPLATE,
            params: {
                type: this.state.container_trip_type,
                rfqId: match.params.id,
                withData,
                isConsignee
            }
        })
    }

    onUploadDoc = (tripIndex, file) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            noSaveUpload: true,
            onSuccess: (data) => { 
                const { trips } = this.state;
                if(!trips[tripIndex]['docs']) {
                    trips[tripIndex]['docs'] = [];
                }
                trips[tripIndex]['docs'].push(data);
                this.setState({ trips });
            }
         });
    }

    addConsignee = () => {
        const { trips } = this.state;
        const cObj = JSON.parse(JSON.stringify(icdDestnToConsigneeObj));
        trips.push({
            consignee_type: 2, 
            provider_type: 2,
            provider_name: 'Transporter',
            ...cObj
        });
        this.setState({ trips });
    }

    downloadUploadedFile = (fileName) => {
        const { dispatch } =  this.props;
        dispatch({
           type: DOWNLOAD_UPLOADED_FILE,
           param: {
              fileName
           }
        });
    }

    onDeleteSlab = (tripIndex, slabIndex) => {
        const { trips } = this.state;
        trips[tripIndex].slabs.splice(slabIndex, 1);
        this.setState({
            trips
        });
    }

    validateDoorToDoor = () => {
        const { trips } = this.state;
        let errorFlag = true;
        if((trips || []).every(trip => 
            (trip.stops[0] || {}).city && (trip.stops[1] || {}).city && trip.origin_yard && trip.destination_yard && trip.movement_type
            && (trip.vehicle_details || {}).vehicle_type && trip.no_of_container && trip.route_code && trip.distance && trip.remarks && (trip.transporters_group || []).length > 0 && 
            trip.slabs.length > 0 && (trip.slabs || []).every(slab => slab.description && slab.slab_name && slab.market_rate && slab.pricing_basis && slab.qbr)
        )) {
            errorFlag = false;
        }
        return errorFlag;
    }

    doorToDoorValidation = (trip) => {
        let errorFlag = false;
        const {container_trip_type} = this.state;
        if((trip.stops[0] || {}).city && (container_trip_type !== 2 ? (trip.stops[1] || {}).city : true) && trip.origin_yard && trip.destination_yard && trip.movement_type
        && (trip.vehicle_details || {}).vehicle_type && trip.no_of_container && trip.route_code && trip.distance && trip.remarks && (trip.transporters_group || []).length > 0 && 
        trip.slabs.length > 0 && (trip.slabs || []).every(slab => slab.description && slab.slab_name && slab.market_rate && slab.pricing_basis && slab.qbr)) {
            errorFlag = true;
        }
        return errorFlag;
    }

    consigneeValidation = (trip) => {
        let errorFlag = false;
        if((trip.stops[0] || {}).city && (trip.stops[1] || {}).city && (trip.vehicle_details || {}).vehicle_type && trip.no_of_trucks && trip.route_code && trip.remarks && (trip.transporters_group || []).length > 0) {
            errorFlag = true;
        }
        return errorFlag;
    }

    handlingAgentValidate = (trip) => {
        let errorFlag = false;
        if((trip.stops[0] || {}).city && trip.origin_yard && trip.movement_type && trip.pricing_basis && trip.market_rate && (trip.bidding_and_payments || {}).qbr && (trip.transporters_group || []).length > 0 && trip.remarks && (trip.docs || []).length > 0) {
            errorFlag = true;
        }
        return errorFlag;
    }

    validateConsigneeToICDDestination = () => {
        const { trips } = this.state;
        let errorFlag = true;
        if((trips || []).every(trip => ((trip.provider_type === 2 && !trip.consignee_type) ? this.doorToDoorValidation(trip) : (trip.provider_type === 21 ? this.handlingAgentValidate(trip) : this.consigneeValidation(trip))))) {
            errorFlag = false;
        }
        return errorFlag;
    }

    validateICDDestination = () => {
        const { trips } = this.state;
        let errorFlag = true;
        if((trips || []).every(trip => this.consigneeValidation(trip))) {
            errorFlag = false;
        }
        return errorFlag;
    }

    validate = () => {
        const { container_trip_type } = this.state;
        let errorFlag = true;
        if(container_trip_type === 1) {
            errorFlag =  this.validateDoorToDoor();
        } else if(container_trip_type === 2) {
            errorFlag = this.validateConsigneeToICDDestination();
        } else if(container_trip_type === 3) {
            errorFlag = this.validateICDDestination(); 
        }
        this.props.setContainerTrip(this.state.trips, errorFlag);
        return errorFlag;
    }

    render() {
        const { containerTypes, multiModalMovementTypes, containerListTypes, slabs, pricingBasis, transporters, vehicleTypes } = this.props;
        const { trips, locationList, container_trip_type, openTransporterPopup, providerType, providerTripIndex, openProviderSelection, selectedProviders } = this.state;
        let consigneeCount = 0;

        return (
            <div>
                {/* {loader && <ActionLoader />} */}
                <div className='tCenter fBold fs-22 pv-10'>Add Trip</div>
                <div className="pv-10 ph-10 bg-theme-light">
                    <div className='flex flex-between mb-5'>
                        <div className={'flex'}>
                            <Dropdown 
                                items={containerTypes}
                                className={Cx("bg-white wt-280", {
                                    'disable-pointer-events': container_trip_type
                                })}
                                displayKey="name"
                                selectedItem={(containerTypes || []).find(el => el.id === container_trip_type)}
                                name="containerTypes" 
                                label="Select" 
                                onSelect={(option) => {
                                    if(option.id === 2) {
                                        this.setState({
                                            openProviderSelection: true,
                                            selectedProviders: [],
                                            selectedOption: option
                                        });
                                    } else {
                                        this.onSelectContanerType(option)
                                    }
                                }}
                            />
                            {container_trip_type === 2 && <button className={'ph-20 button-bg-color white-color fBold br-5 ht-40 fs-16 ml-10'} onClick={this.addConsignee}>+ ICD Destination To Consignee</button>}
                        </div>
                        {/* {container_trip_type && <div className='flex flex-between wt-400'>
                            <div className='theme-color fs-16 fBold flex mt-5 curP' onClick={() => this.onDownload(false)}>
                                <DownloadIcon className='wt-15 ht-25 mr-5'/>
                                <div className='mt-5'>{'Template'}</div>
                            </div>
                            <div className='theme-color fs-16 fBold flex mt-5 curP'>
                                <Upload onChange={this.uploadTrips} value="Upload File">
                                    <button className='theme-color bg-theme-light fs-16 fBold flex'>
                                    <UploadIcon className='wt-15 ht-25 mr-5'/><div className='mt-5'>Upload</div></button>
                                </Upload> 
                            </div>
                            <div className='theme-color fs-16 fBold flex mt-5 mr-20 curP'  onClick={() => this.onDownload(true)}>
                                <DownloadIcon className='wt-15 ht-25 mr-5'/>
                                <div className='mt-5'>{'Download Details'}</div>
                            </div>
                        </div>} */}
                    </div>

                    {(trips || []).map((trip, tripIndex) => {
                        if(trip.consignee_type) {
                            consigneeCount += 1;
                            trip.consigneeCount = consigneeCount;
                        }
                        return(
                        <div className={Cx('bg-white ph-10 br-5', {
                            'bg-m-blue': trip.consignee_type,
                            'mb-20': container_trip_type !== 2,
                            'bg-white': !trip.consignee_type,
                            'pv-10': !trip.consigneeCount,
                            'pt-10': trip.consigneeCount,
                            'border-top-black': trip.provider_type === 21
                        })}>
                            {(container_trip_type === 1 || (container_trip_type === 2 && trip.provider_type === 2 && !trip.consignee_type))
                             && <DoorToDoor 
                                    trip={trip}
                                    multiModalMovementTypes={multiModalMovementTypes}
                                    containerListTypes={containerListTypes}
                                    tripIndex={tripIndex}
                                    onSelect={this.onSelect}
                                    onChange={this.onChange}
                                    onSelectLocation={this.onSelectLocation}
                                    locationList={locationList}
                                    onChangeTrip={this.onChangeTrip}
                                    onAddSlab={this.onAddSlab}
                                    slabs={slabs}
                                    pricingBasis={pricingBasis}
                                    onSelectSlab={this.onSelectSlab}
                                    onChangeSlab={this.onChangeSlab}
                                    onDeleteTrip={this.onDeleteTrip}
                                    onAddTrip={this.onAddTrip}
                                    openProviderPopup={this.openProviderPopup}
                                    onDeleteTransporter={this.onDeleteTransporter}
                                    onCancel={this.onCancel}
                                    container_trip_type={container_trip_type}
                                    onDeleteSlab={this.onDeleteSlab}
                                    onSelectRoutestage={this.onSelectRoutestage}
                                    sourceICDBranch={this.props.sourceICDBranch}
                                    allICDBranch={this.props.allICDBranch}
                            />}

                            {trip.provider_type === 21 && 
                                <HandlingAgent
                                    onUploadDoc={this.onUploadDoc}
                                    trip={trip}
                                    multiModalMovementTypes={multiModalMovementTypes}
                                    containerListTypes={containerListTypes}
                                    tripIndex={tripIndex}
                                    onSelect={this.onSelect}
                                    onChange={this.onChange}
                                    onSelectLocation={this.onSelectLocation}
                                    locationList={locationList}
                                    onChangeTrip={this.onChangeTrip}
                                    slabs={slabs}
                                    pricingBasis={pricingBasis}
                                    onDeleteTrip={this.onDeleteTrip}
                                    onAddTrip={this.onAddTrip}
                                    openProviderPopup={this.openProviderPopup}
                                    onDeleteTransporter={this.onDeleteTransporter}
                                    onCancel={this.onCancel}
                                    container_trip_type={container_trip_type}
                                    downloadUploadedFile={this.downloadUploadedFile}
                                    trips={trips}
                                />
                            }
                            {
                                trip.consignee_type === 2 &&
                                <Consignee 
                                    trip={trip}
                                    multiModalMovementTypes={multiModalMovementTypes}
                                    containerListTypes={containerListTypes}
                                    tripIndex={tripIndex}
                                    onSelect={this.onSelect}
                                    onChange={this.onChange}
                                    onSelectLocation={this.onSelectICDDestnToConsigneeLocation}
                                    locationList={locationList}
                                    onChangeTrip={this.onChangeTrip}
                                    pricingBasis={pricingBasis}
                                    onDeleteTrip={this.onDeleteTrip}
                                    onAddTrip={this.onAddTrip}
                                    openProviderPopup={this.openProviderPopup}
                                    onDeleteTransporter={this.onDeleteTransporter}
                                    onCancel={this.onCancel}
                                    vehicleTypes={vehicleTypes}
                                    uploadTrips={this.uploadTrips}
                                    onDownload={this.onDownload}
                                    consigneeCount={consigneeCount}
                                />
                            }

                            {container_trip_type === 3 && 
                                <ICDDestnToConsignee 
                                    trip={trip}
                                    multiModalMovementTypes={multiModalMovementTypes}
                                    containerListTypes={containerListTypes}
                                    tripIndex={tripIndex}
                                    onSelect={this.onSelect}
                                    onChange={this.onChange}
                                    onSelectLocation={this.onSelectICDDestnToConsigneeLocation}
                                    locationList={locationList}
                                    onChangeTrip={this.onChangeTrip}
                                    pricingBasis={pricingBasis}
                                    onDeleteTrip={this.onDeleteTrip}
                                    onAddTrip={this.onAddTrip}
                                    openProviderPopup={this.openProviderPopup}
                                    onDeleteTransporter={this.onDeleteTransporter}
                                    onCancel={this.onCancel}
                                    vehicleTypes={vehicleTypes}
                                    onAddSlab={this.onAddSlab}
                                    slabs={slabs}
                                    onSelectSlab={this.onSelectSlab}
                                    onChangeSlab={this.onChangeSlab}
                                    onDeleteSlab={this.onDeleteSlab}
                            />}
                        </div>)
                        })
                    }
                </div>
                {this.state.icdDestError && <div className='error-color p-5 tCenter fs-16'> {this.state.icdDestError} </div>}
                {container_trip_type && (trips || []).length > 0 &&  <div className="pl-30 pv-10 col-1 tCenter">
                    <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 mr-20" onClick={this.onCancel}>Cancel</button>
                    <button className={Cx("b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 mr-20", {
                        'notselectable': this.validate()
                    })} onClick={this.onSave}>Save</button>
                </div>}
                {openTransporterPopup && transporters.length > 0 && <Overlay>
                    <div className="z-100 box-shadow pf t-0 col-1 bg-white pv-10 ht-40 border-bottom-theme">
                        <Heading 
                            text={providerType === 2 ? 'Transporter' : 'Handling Agent'} 
                            className="tCenter"/>
                        <CancelIcon onClick={this.openProviderPopup} className="wt-15 ht-15 theme-fill pa curP mt-10 t-0 r-0 mr-5" />
                    </div>
                    <div className="flex pv-10 ph-20 mb-20 min-ht-250 t-20 mt-30 overflowAuto min-wt-250 max-wt-900 max-ht-700">
                        {(transporters || []).map(transGroup => (
                            <div className="mr-10 wt-250">
                                <GroupContainer
                                    group={transGroup}
                                    toggleAllTransporters={this.toggleAllTransporters.bind(this, transGroup, providerTripIndex)}
                                    toggleTransporter={this.toggleTransporter.bind(this, providerTripIndex)}
                                    selectedTransporters={trips[providerTripIndex].transporters_group || []}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="z-100 box-shadow pl-40 pv-10 pf b-0 col-1 bg-white">
                        <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.openProviderPopup}>Save</button>
                        <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.openProviderPopup}>Cancel</button>
                    </div>
                </Overlay>}
                {openProviderSelection && 
                    <Overlay>
                        <div className="z-100 box-shadow pf t-0 col-1 bg-white pv-10 ht-40 border-bottom-theme">
                            <Heading 
                                text={'Providers'} 
                                className="tCenter"/>
                            <CancelIcon onClick={() => {
                                this.setState({ selectedProviders: [], openProviderSelection: false })
                            }} className="wt-15 ht-15 theme-fill pa curP mt-10 t-0 r-0 mr-5" />
                        </div>
                        <div className="pv-10 ph-20 mb-20 ht-150 t-20 mt-30 overflowAuto min-wt-250 ">
                            {
                                (providers || []).map((pTrans, index)=> {
                                    return (
                                        <div key={index} className="pv-5 fs-16 fSemibold  flex pl-40 flex-between">
                                            <Checkbox type='square' id={pTrans.provider_type} onCheck={()=> {
                                                // this.props.toggleTransporter(transporter, group);
                                                const findChild = selectedProviders.findIndex(el => el['provider_type'] === pTrans['provider_type']);
                                                
                                                if(findChild > -1) {
                                                    if(pTrans.provider_type == 2){
                                                        selectedProviders.splice(findChild, 1); 
                                                        const findHandlingAgent = selectedProviders.findIndex(el => el['provider_type'] == 21);
                                                
                                                        selectedProviders.splice(findHandlingAgent, 1);
                                                    } else{
                                                        selectedProviders.splice(findChild, 1);
                                                    }
                                                } else {
                                                    if(pTrans.provider_type == 2){
                                                        selectedProviders.push(pTrans)
                                                        selectedProviders.push({provider_name: "Handling Agent", provider_type: 21})
                                                    } else{
                                                        selectedProviders.push(pTrans)
                                                    }
                                                }
                                                this.setState({ selectedProviders });
                                            }}
                                            checked={selectedProviders.find(el => el['provider_type'] === pTrans['provider_type'])}
                                            />
                                            <label className="wt-87p mr-10">
                                                {pTrans['provider_name']}
                                            </label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="z-100 box-shadow pl-30 pv-10 pf b-0 col-1 bg-white flex">
                            <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 mr-20 fRight" onClick={() => this.setState({ openProviderSelection: false, selectedProviders: [] })}>Cancel</button>
                            <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 mr-20 fRight" onClick={() => {
                                this.onSelectContanerType(this.state.selectedOption);
                                this.setState({ openProviderSelection: false });
                            }}>Save</button>
                        </div>
                    </Overlay>
                }
            </div>
        )
    }
}


const mapStateToProps = ({ constants }) => {
    return {
        containerTypes: constants.containerTypes || [],
        multiModalMovementTypes: constants.multiModalMovementTypes || [],
        containerListTypes: constants.containerListTypes || [],
        slabs: constants.slabs || [],
        pricingBasis: constants.pricingBasis || [],
        sourceICDBranch: constants.sourceICDBranch || [],
        allICDBranch: constants.allICDBranch || [],
        destinationICDRouteCode: constants.destinationICDRouteCode || []
    }
}

export default connect(mapStateToProps)(withRouter(ContainerTrips));